module.exports = __webpack_public_path__ + "static/Crisp-0e6965c32bfc03d35d89e2e2d9ef3268.png";